module.exports = __webpack_public_path__ + "static/media/resources.5fc906cf.jpg";